export default __webpack_public_path__ + "static/media/Q12022.f6661cdc.PDF";